import { Component } from '@angular/core';
import {
  DavaService,
  DavaAddressInfo,
  DmrResponse,
  DmrService,
  HelvetiaVariant,
  InsuranceInfo,
  InsuranceInfoService,
  LibUtilityService,
  ResetPriceCalculator,
  UpdateKsfTemplate,
  helvetiaCustomerInfo,
  ksfExcessTab,
  ksfCustomerInfo,
} from 'projects/shared/src/public-api';
import { finalize } from 'rxjs';
import { TrackingService } from './services/tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private dmrService: DmrService,
    private davaService: DavaService,
    private insuranceInfoService: InsuranceInfoService,
    private libUtilityService: LibUtilityService,
    private resetPriceCalculator: ResetPriceCalculator,
    private trackingService: TrackingService,
  ) {}

  title: string = '';

  activeStep: number = 0;
  numberOfSteps = 7;
  requireAuth = false;
  errorInKsfPrice: boolean = false;
  errorInHelvetiaPrice: boolean = false;
  errorInZipCode: boolean = false;
  errorInRegOrVinNumber: boolean = false;
  errorInCarPrice: boolean = false;
  errorInCustomerAge: boolean = false;
  errorInPurchasedOrLeased: boolean = false;
  errorIngetInsurancePrices: boolean = false;

  loadingDmrScrape: boolean = false;
  loadinginsuranceInfo: boolean = false;
  loadingRegOrVinNumber: boolean = false;

  showYearlyPrice: boolean = false;
  isZipcodeValid: boolean = false;
  isCustomerAgeValid: boolean = false;
  receivedDMRVehicle: boolean = false;
  regOrVinNumberInputFocused: boolean = false;
  specialCarError: boolean = false;
  allHaveTogglePricetag: boolean = false;

  zipCode: number | null = null;
  regOrVinNumber = '';
  carOwnershipType = '';
  customerAge: number | null = null;
  selectedPrice: { name: string; value: number } = { name: '', value: 0 };
  helvetiaVariants: HelvetiaVariant[] = [];
  selectedHelvetiaVariant: HelvetiaVariant = {} as HelvetiaVariant;
  helvetiaMonthlyPrice: number = 0;
  helvetiaYearlyPrice: number = 0;
  vehicleFromDmr: DmrResponse = {} as DmrResponse;

  ksfPriceResult: any = null;
  ksfTemplate: UpdateKsfTemplate = {} as UpdateKsfTemplate;
  ksfExcessTab: ksfExcessTab = {
    value: 0,
    valueText: '',
  };
  ksfPrice: number = 0;
  ksfMonthlyPrice: number = 0;
  showHelvetiaInfo: boolean = false;
  showKsfInfo: boolean = false;
  helvetiaCustomerInfo: helvetiaCustomerInfo = {
    showAsBusinessCustomer: false,
    cprNumber: '',
    cvrNumber: '',
    firstname: '',
    lastname: '',
    companyName: '',
    selectedAddressInfo: {} as DavaAddressInfo,
    email: '',
    phoneNumber: '',
    extraUserType: '',
    extraUserCvrNumber: '',
    extraUserCompanyName: '',
    extraUserCprNumber: '',
    extraUserFirstname: '',
    extraUserLastname: '',
    extraUserSelectedAddressInfo: {} as DavaAddressInfo,
  };
  ksfCustomerInfo: ksfCustomerInfo = {
    cprNumber: '',
    firstname: '',
    lastname: '',
    selectedAddressInfo: {} as DavaAddressInfo,
    email: '',
    phoneNumber: '',
  };

  dropdown_carPrice = [
    { name: '0 - 50.000 kr.', value: 50000 },
    { name: '50.001 - 100.000 kr.', value: 100000 },
    { name: '100.001 - 150.000 kr.', value: 150000 },
    { name: '150.001 - 200.000 kr.', value: 200000 },
    { name: '200.001 - 250.000 kr.', value: 250000 },
    { name: '250.001 - 300.000 kr.', value: 300000 },
    { name: '300.001 - 350.000 kr.', value: 350000 },
    { name: '350.001 - 400.000 kr.', value: 400000 },
    { name: '400.001 - 450.000 kr.', value: 450000 },
    { name: '450.001 - 500.000 kr.', value: 500000 },
    { name: '500.001 - 550.000 kr.', value: 550000 },
    { name: '550.001 - 600.000 kr.', value: 600000 },
    { name: '600.001 - 650.000 kr.', value: 650000 },
    { name: '650.001 - 700.000 kr.', value: 700000 },
    { name: '700.001 - 750.000 kr.', value: 750000 },
    { name: '750.001 - 800.000 kr.', value: 800000 },
    { name: '800.001 - 850.000 kr.', value: 850000 },
    { name: '850.001 - 900.000 kr.', value: 900000 },
    { name: '900.001 - 950.000 kr.', value: 950000 },
    { name: '950.001 - 1.000.000 kr.', value: 1000000 },
    { name: '1.000.001 - 1.050.000 kr.', value: 1050000 },
    { name: '1.050.001 - 1.100.000 kr.', value: 1100000 },
    { name: '1.100.001 - 1.150.000 kr.', value: 1150000 },
    { name: '1.150.001 - 1.200.000 kr.', value: 1200000 },
    { name: '1.200.001 - 1.250.000 kr.', value: 1250000 },
    { name: '1.250.001 - 1.300.000 kr.', value: 1300000 },
    { name: '1.300.001 - 1.350.000 kr.', value: 1350000 },
    { name: '1.350.001 - 1.400.000 kr.', value: 1400000 },
    { name: '1.400.001 - 1.450.000 kr.', value: 1450000 },
    { name: '1.450.001 - 1.500.000 kr.', value: 1500000 },
    { name: '1.500.001 - 1.550.000 kr.', value: 1550000 },
    { name: '1.550.001 - 1.600.000 kr.', value: 1600000 },
    { name: '1.600.001 - 1.650.000 kr.', value: 1650000 },
    { name: '1.650.001 - 1.700.000 kr.', value: 1700000 },
    { name: '1.700.001 - 1.750.000 kr.', value: 1750000 },
    { name: '1.750.001 - 1.800.000 kr.', value: 1800000 },
    { name: '1.800.001 - 1.850.000 kr.', value: 1850000 },
    { name: '1.850.001 - 1.900.000 kr.', value: 1900000 },
    { name: '1.900.001 - 1.950.000 kr.', value: 1950000 },
    { name: '1.950.001 - 2.000.000 kr.', value: 2000000 },
  ];

  reset() {
    // Reset this components data
    this.resetBaseInfo();
    // reset all data in the app-helvetia-price-calculator component in this app
    this.resetPriceCalculator.resetPriceCalculatorValues.next('');
  }

  resetBaseInfo() {
    this.activeStep = 0;
    this.numberOfSteps = 7;

    this.errorInZipCode = false;
    this.isZipcodeValid = false;
    this.errorInCustomerAge = false;
    this.isCustomerAgeValid = false;

    this.showYearlyPrice = false;
    this.helvetiaVariants = [];
    this.selectedHelvetiaVariant = {} as HelvetiaVariant;

    this.helvetiaMonthlyPrice = 0;
    this.helvetiaYearlyPrice = 0;
    this.vehicleFromDmr = {} as DmrResponse;
    this.receivedDMRVehicle = false;

    this.carOwnershipType = '';
    this.selectedPrice = { name: '', value: 0 };

    this.customerAge = null;
    this.zipCode = null;
  }

  emitTrackingEvnet() {
    if (this.activeStep < 7) {
      // 7 is the complete step
      const eventName = `Step_${this.activeStep}_complete`;

      if (this.activeStep === 6) {
        this.trackingService.trackEvent(
          eventName,
          this.getTrackingCustomerData(),
        );
      } else {
        this.trackingService.trackEvent(eventName);
      }
    } else {
      const eventName = 'Flow_complete';
      this.trackingService.trackEvent(
        eventName,
        this.getTrackingCustomerData(),
      );
    }
  }

  getTrackingCustomerData() {
    if (this.showHelvetiaInfo) {
      return {
        first_name: this.helvetiaCustomerInfo.firstname,
        last_name: this.helvetiaCustomerInfo.lastname,
        email: this.helvetiaCustomerInfo.email,
        phone: this.helvetiaCustomerInfo.phoneNumber,
      };
    }

    if (this.showKsfInfo) {
      return {
        first_name: this.ksfCustomerInfo.firstname,
        last_name: this.ksfCustomerInfo.lastname,
        email: this.ksfCustomerInfo.email,
        phone: this.ksfCustomerInfo.phoneNumber,
      };
    }

    return undefined;
  }

  nextStep() {
    ++this.activeStep;
    this.emitTrackingEvnet();
  }

  dmrInfo() {
    // We this if you allready sercach for a car, and insertet the basic info, and deside to go back.
    this.reset();

    this.receivedDMRVehicle = false;
    this.specialCarError = false;
    this.errorInRegOrVinNumber = false;
    this.regOrVinNumber = this.regOrVinNumber.replace(/\s/g, '');

    if (this.regOrVinNumber.length < 6) {
      this.errorInRegOrVinNumber = true;
      return;
    }

    this.errorInRegOrVinNumber = false;

    // Reg number
    // Handle registration number
    if (this.regOrVinNumber.trim().length < 10) {
      this.loadingRegOrVinNumber = true;
      this.dmrService
        .getVehicleByRegNumber(this.regOrVinNumber, false)
        .subscribe({
          next: (result: any) => {
            this.vehicleFromDmr = result.vehicle;
            this.loadingRegOrVinNumber = false;

            if (this.checkIfSpecialCarsBrand(this.vehicleFromDmr.make)) {
              this.receivedDMRVehicle = false;
              this.specialCarError = true;
            } else {
              this.receivedDMRVehicle = true;
            }
          },
          error: (error) => {
            this.errorInRegOrVinNumber = true;
            this.loadingRegOrVinNumber = false;
            this.receivedDMRVehicle = false;

            console.error(error);
            return;
          },
        });
    } else {
      // Handle VIN number
      this.loadingRegOrVinNumber = true;

      this.dmrService
        .getVehicleByVINNumber(this.regOrVinNumber, false)
        .subscribe({
          next: (result: any) => {
            this.vehicleFromDmr = result.vehicleInfo;
            this.loadingRegOrVinNumber = false;

            if (this.checkIfSpecialCarsBrand(this.vehicleFromDmr.make)) {
              this.receivedDMRVehicle = false;
              this.specialCarError = true;
            } else {
              this.receivedDMRVehicle = true;
            }
          },
          error: (error) => {
            this.errorInRegOrVinNumber = true;
            this.loadingRegOrVinNumber = false;
            this.receivedDMRVehicle = false;

            console.error(error);
            return;
          },
        });
    }
  }

  dmrScrape() {
    // Reg number
    this.loadingDmrScrape = true;
    if (this.regOrVinNumber.length == 7) {
      this.dmrService
        .scrapeVehicleByRegNumber(this.regOrVinNumber, this.requireAuth)
        .subscribe({
          next: (result: any) => {
            this.loadingDmrScrape = false;
            this.vehicleFromDmr = result.vehicle;

            if (this.checkIfSpecialCarsBrand(this.vehicleFromDmr.make)) {
              this.receivedDMRVehicle = false;
              this.specialCarError = true;
            }
          },
          error: (error) => {
            this.loadingDmrScrape = false;
            console.error(error);
            return;
          },
        });
    } else {
      // Vin number
      this.dmrService
        .scrapeVehicleByVINNumber(this.regOrVinNumber, this.requireAuth)
        .subscribe({
          next: (result: any) => {
            this.loadingDmrScrape = false;
            this.vehicleFromDmr = result.vehicleInfo;

            if (this.checkIfSpecialCarsBrand(this.vehicleFromDmr.make)) {
              this.receivedDMRVehicle = false;
              this.specialCarError = true;
            }
          },
          error: (error) => {
            this.loadingDmrScrape = false;
            console.error(error);
            return;
          },
        });
    }
  }

  checkIfSpecialCarsBrand(brand: string) {
    const specialCarsBrands = [
      'ASTON MARTIN',
      'ALPINA',
      'BENTLEY',
      'BUGATTI',
      'HUMMER',
      'LAMBORGHINI',
      'MCLAREN',
      'ROLLS-ROYCE',
      'DE TOMASO',
      'KOENIGSEGG',
      'PAGANI',
      'ZENVO',
      'RUF',
      'RIMAC',
      'FISKER',
    ];

    return specialCarsBrands.includes(brand);
  }

  previousStep() {
    if (this.activeStep !== 0) {
      --this.activeStep;
    }
    // if the activeStep is 2, where we show prices, we reset the number of steps
    if (this.activeStep === 2) {
      this.numberOfSteps = 7;
    }
  }

  dropdownOutput(item: any, dropdownId: string) {
    if (dropdownId == 'price') {
      this.selectedPrice = item;
      this.errorInCarPrice = this.selectedPrice.value == 0 ? true : false;
    }
  }

  validateBasicInfo() {
    this.errorInHelvetiaPrice = false;
    this.errorInKsfPrice = false;

    this.errorInPurchasedOrLeased = false;
    this.errorInCustomerAge = false;
    this.errorInZipCode = false;
    this.errorInCarPrice = false;

    if (
      !this.receivedDMRVehicle ||
      !this.regOrVinNumber.replace(/\s/g, '') ||
      !this.carOwnershipType ||
      !this.zipCode ||
      !(this.zipCode > 1000 && this.zipCode < 10000) ||
      !this.customerAge ||
      this.customerAge > 120 ||
      this.customerAge < 18 ||
      this.selectedPrice.value === 0
    ) {
      this.errorInRegOrVinNumber =
        !this.regOrVinNumber || !this.receivedDMRVehicle;
      this.errorInPurchasedOrLeased = !this.carOwnershipType.trim();
      this.errorInCustomerAge =
        !this.customerAge || this.customerAge > 120 || this.customerAge < 18;
      this.errorInZipCode =
        !this.zipCode || !(this.zipCode > 1000 && this.zipCode < 9999);
      this.errorInCarPrice = this.selectedPrice.value === 0;

      return;
    }

    this.getInsurancePrices();
  }

  getInsurancePrices() {
    this.errorInHelvetiaPrice = false;
    this.errorInKsfPrice = false;

    this.loadinginsuranceInfo = true;

    if (this.customerAge && this.zipCode) {
      /*     this.davaService.davaAutoComplete(`${this.zipCode}`).subscribe({
        next: (result: any) => { */
      /*       const customerAddress = result.find(
            (address: any) => address.adresse.postnr === this.zipCode,
          );
           */
      const insuranceInfo: InsuranceInfo = {
        customerType: 'private', // private/business
        driverAge: this.customerAge!,
        financingType: this.carOwnershipType,
        postCode: this.zipCode!,
        vehicleMake: this.vehicleFromDmr.make,
        vehicleModel: this.vehicleFromDmr.model,
        vehicleType: this.vehicleFromDmr.type,
        vehiclePrice: this.selectedPrice.value,
        vehicleHorsepower: this.vehicleFromDmr.horsepower,
        vehicleFuelType: this.vehicleFromDmr.fuelType,
        vehicleCode: this.vehicleFromDmr.code,
        vehicleExpectedYearlyMileage: 14999,
        vehicleClaims: 0,
        serviceAgreement: 0,
        isPrivatePrimaryDriver: 1,
        registrationNumber: this.vehicleFromDmr.registrationPlate,
        vehicleAftermarketAccessories: 1,
        customerStreet: 'null',
        forsiaInsuranceExcess: 0,
        vehiclePluginHybrid: this.vehicleFromDmr.pluginHybrid ? 1 : 0,
      };

      // only add vehicleOwnWeight if we get a value from dmr
      if (this.vehicleFromDmr.ownWeight) {
        insuranceInfo.vehicleOwnWeight = this.vehicleFromDmr.ownWeight;
      }

      // only add firstRegistrationDate if we get a value from dmr
      if (this.vehicleFromDmr.firstRegistrationDate) {
        insuranceInfo.vehicleFirstRegistrationDate =
          this.vehicleFromDmr.firstRegistrationDate;
      }

      this.insuranceInfoService
        .getInsurancePrices(insuranceInfo, false)
        .pipe(
          finalize(() => {
            // This runs when observable completes or errors
            this.loadinginsuranceInfo = false;
          }),
        )
        .subscribe({
          next: (result: any) => {
            // KSF Prices
            const ksfPrices = result.KF;
            if (
              ksfPrices &&
              !result.KF.error &&
              result.KF.state !== 'Warnings'
            ) {
              this.ksfPriceResult = ksfPrices;

              this.ksfTemplate.templateId = ksfPrices.policyTemplateCacheId;
              this.setKsTemplate(ksfPrices);

              const excessLiability = ksfPrices.covers.find(
                (c: any) => c.id === 10071,
              );
              const comprehensive = ksfPrices.covers.find(
                (c: any) => c.id === 10072,
              );

              // Calculate total KSF price including cover premiums and taxes/fees
              this.ksfPrice =
                comprehensive.coverPremium +
                excessLiability.coverPremium +
                this.libUtilityService.getKsfTaxAndFeesPrice(ksfPrices);

              this.ksfMonthlyPrice = this.ksfPrice / 12;

              // Set the default selected deductible tab based on the response
              this.ksfExcessTab = ksfPrices.deductibles[0].type.selectList.find(
                (item: any) => item.value === ksfPrices.deductibles[0].value,
              );
            } else {
              this.errorInKsfPrice = true;
            }

            const dateObject = new Date(
              this.vehicleFromDmr.firstRegistrationDate,
            );
            const year = dateObject.getFullYear();
            const currentYear = new Date().getFullYear();

            const helvetiaPrices = result.Helvetia;
            if (
              helvetiaPrices &&
              !result.Helvetia.error &&
              this.selectedPrice.value <= 1300000 && // Max allowed price is 1.3 million
              currentYear - year <= 30
            ) // Max age of the car is 30 years
            {
              this.helvetiaVariants = helvetiaPrices;

              // TODO: Map all the properties over here for Helvetia.

              // Default to the Gold variant for Helvetia
              this.selectedHelvetiaVariant = this.helvetiaVariants[2];

              // Calculate monthly and yearly prices for Helvetia
              this.helvetiaMonthlyPrice =
                this.libUtilityService.getHelvetiaPrice(
                  this.selectedHelvetiaVariant.coverages,
                  'monthly',
                );
              this.helvetiaYearlyPrice =
                this.libUtilityService.getHelvetiaPrice(
                  this.selectedHelvetiaVariant.coverages,
                  'yearly',
                );

              this.loadinginsuranceInfo = false;
              this.errorIngetInsurancePrices = false;

              this.nextStep();
            } else {
              this.errorInHelvetiaPrice = true;
            }
          },
          error: (error) => {},
        });
      /*  },
        error: (error) => {}, */
      /*   }; */
    }
  }

  pickHelvetiaPrice(goToNextStep: boolean) {
    this.showHelvetiaInfo = true;
    this.showKsfInfo = false;

    if (goToNextStep) {
      this.nextStep();
    }
  }

  validateCustomerAge() {
    if (this.customerAge && this.customerAge.toString().length >= 2) {
      if (this.customerAge > 120 || this.customerAge < 18) {
        this.errorInCustomerAge = true;
        this.isCustomerAgeValid = false;
      } else {
        this.errorInCustomerAge = false;
        this.isCustomerAgeValid = true;
      }
    } else {
      this.errorInCustomerAge = false;
      this.isCustomerAgeValid = false;
    }
  }

  validateZipCode() {
    if (this.zipCode && this.zipCode.toString().length >= 4) {
      if (this.zipCode > 9999) {
        this.errorInZipCode = true;
        this.isZipcodeValid = false;
      } else {
        this.errorInZipCode = false;
        this.isZipcodeValid = true;
      }
    } else {
      this.errorInZipCode = false;
      this.isZipcodeValid = false;
    }
  }

  priceFilterFunction = (option: any, selectedValue: string): boolean => {
    if (!selectedValue.trim()) {
      return option;
    }

    const [lowerBound, upperBound] = option.name.split(' - ');

    const upperBoundNumber = parseFloat(
      upperBound.replace(' kr.', '').replace(/\./g, ''),
    );
    const lowerBoundNumber = parseFloat(
      lowerBound.replace(' kr.', '').replace(/\./g, ''),
    );

    const selectedNumber = parseFloat(selectedValue.replace(/\./g, ''));

    /* Retruns options where the serach values is included or is in range  */
    return (
      (selectedNumber >= lowerBoundNumber &&
        selectedNumber <= upperBoundNumber) ||
      option.name.includes(selectedValue.toLowerCase())
    );
  };

  /**
   * Sets the `ksfTemplate` with the necessary information
   * This method ensures that the template is properly prepared with
   * the correct information for further operations.
   * @returns void
   */
  setKsTemplate(ksfPrices: any): void {
    if (this.customerAge && this.zipCode) {
      // Set driver age and postcode based on customer information
      this.ksfTemplate.driverAge = this.customerAge;
      this.ksfTemplate.driverPostcode = `${this.zipCode}`;

      // Map and set the selected covers in the template
      this.ksfTemplate.covers = ksfPrices.covers.map((cover: any) => ({
        Id: `${cover.id}`, // Ensure Id is a string
        Selected: cover.selected,
      }));

      // Map and set the deductibles in the template
      this.ksfTemplate.deductibles = ksfPrices.deductibles.map(
        (deductible: any) => ({
          Id: `${deductible.id}`, // Ensure Id is a string
          Value: deductible.value,
        }),
      );

      // Map and set the fields in the template
      this.ksfTemplate.fields = ksfPrices.fields.map((field: any) => ({
        Id: `${field.id}`, // Ensure Id is a string
        Value: field.value,
      }));
    }
  }

  pickKsf(goToNextStep: boolean) {
    this.showKsfInfo = true;
    this.showHelvetiaInfo = false;

    if (goToNextStep) {
      this.nextStep();
    }
  }
}
